import { Routes } from '@angular/router';

export const motionSensorRoutes: Routes = [
  // активувати після того як Нестор внесе зміни в себе.
  // {
  //   path: '',
  //   component: MotionSensorComponent,
  //   children: [
  //     {
  //       path: '',
  //       redirectTo: ClinicNavigationEnum.analytics,
  //       pathMatch: 'full',
  //     },
  //     {
  //       path: ClinicNavigationEnum.analytics,
  //       component: MotionSensorAnalyticsComponent,
  //     },
  //     {
  //       path: ClinicNavigationEnum.expert_system,
  //       component: MotionSensorExpertSystemComponent,
  //     },
  //     {
  //       path: ClinicNavigationEnum.report,
  //       component: MotionSensorReportComponent,
  //     },
  //   ],
  // },
];
